import { API } from 'config/axios'

const requests = {
  auth: {
    login: (body) => API.post('/auth/login', body),
    register: (body) => API.post('/auth/register', body),
    updateUser: (body) => API.post('/auth/updateUser', body),
    getUsers: (id,search) => API.get('/auth/getUsers', { params: { id,search } }),
    deleteUser: (id) => API.delete(`/auth/deleteUser/${id}`), // Kullanıcı silme için DELETE isteği


  },
  dashboard: {
    getTotalCount: () => API.get('/list/getTotalCount')
  },

  company: {
    list: (params) => API.get('/list/company', { params }),
    get: (id) => API.get('/list/company/' + id),
    create: (body) => API.post('/company/create', body)
  },
  brand: {
    list: () => API.get('/list/brand'),
    listDepartment: (id) => API.get('/list/department/' + id),
    listSubDepartment: (id) => API.get('/list/subDepartment/' + id)
  },
  country: {
    list: (params) => API.get('/list/country', { params }),
    get: (id) => API.get('/list/country/' + id),
    listHome: (params) => API.get('/list/countryHome', { params }),
    getHome: (id) => API.get('/list/countryHome/' + id)
  },
  homeproducts:{
    list:()=>API.get('/list/zaraHomeProducts')
  },
  size: {
    listGroup: (department, params = {}) => API.get('/list/sizeGroup', { params: { department, ...params } }),
    listGroupHome: (department, params = {}) => API.get('/list/sizeGroupHome', { params: { department, ...params } }),
    getGroup: (id) => API.get('/list/sizeGroup/' + id),
    getGroupHome: (id) => API.get('/list/sizeGroupHome/' + id)
  },
  referance: {
    list: (params) => API.get('/list/referance', { params: typeof params === 'string' ? { subDepartment: params } : params }),
    get: (id) => API.get('/list/referance/' + id)
  },
  symbol: {
    list: (washType) => API.get(`/list/symbol/${washType}`),
    listHome: (washType) => API.get(`/list/symbolHome/${washType}`)
  },
  additionalPhrases: {
    list: (params) => API.get('/list/additionalPhrases', { params }),
    washList: (params) => API.get('/list/washingAdditionalPhrases', { params }),
    washListHome: (params) => API.get('/list/washingAdditionalPhrasesHome', { params })
  },
  fabric: {
    list: (params) => API.get('/list/fabric', { params }),
    typeList: (params) => API.get('/list/fabricType', { params }),
    listHome: (params) => API.get('/list/fabricHome', { params }),
    typeListHome: (params) => API.get('/list/fabrictypeHome', { params }),
    lang: (name) => API.get('/list/fabricTranslate/' + name),
    langHome: (name) => API.get('/list/fabricTranslateHome/' + name)
  },
  order: {
    create: (body) => API.post('/order/create', body),
    createwarning: (body) => API.post('/order/createwarning', body),
    createprice: (body) => API.post('/order/createprice', body),
    createbelt: (body) => API.post('/order/createbelt', body),
    createbrand: (body) => API.post('/order/createbrand', body),
    addZaraHomeProduct: (body) => API.post('/order/addZaraHomeProduct', body),
    updateZaraHomeProduct: (body) => API.post('/order/updateZaraHomeProduct', body),
    createaddional: (body) => API.post('/order/createaddional', body),
    createcord: (body) => API.post('/order/createcord', body),    
    createempty: (body) => API.post('/order/createempty', body),
    getBrandSvg: (code, params) => API.get(`/order/getBrandSvg/${code}`, { params: params }) ,
    getBrandSvgHome: (code, params) => API.get(`/order/getBrandSvgHome/${code}`, { params: params }) ,
     convertPdfToSvg: (formData) => API.post('/order/convertPdfToSvg', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }),

    updateprice: (id, body) => API.post('/order/updateprice/' + id, body),
    updatewarning: (id, body) => API.post('/order/updatewarning/' + id, body),
    updatebelt: (id, body) => API.post('/order/updatebelt/' + id, body),
    updatebrand: (id, body) => API.post('/order/updatebrand/' + id, body),
    updateaddional: (id, body) => API.post('/order/updateaddional/' + id, body),
    updatecord: (id, body) => API.post('/order/updatecord/' + id, body),
    updateempty: (id, body) => API.post('/order/updateempty/' + id, body),


    update: (id, body) => API.post('/order/update/' + id, body),
    updateStatus: (id, body) => API.post('/order/updateStatus/' + id, body),
    list: (status,page, search) => API.get('/order/list?status=' + status, { params: { page,search } }),
    get: (id) => API.get('/order/' + id),
    getArtworkOrder: (id, tab) => API.get('/list/artwork/' + id, { params: { tab } }),
    getArtworkOrderHome: (id, tab) => API.get('/list/artworkHome/' + id, { params: { tab } }),
    copyOrder: (id) => API.get('/order/copyOrder', { params: { id } }),
    addSymbolTranslate: (body) => API.post('/order/symbolTranslate', body),
    addReferenceCode: (body) => API.post('/order/addReferenceCode', body),
    deleteReferenceCode: (body) => API.post('/order/deleteReferenceCode', body),
    updateReferenceCode: (body) => API.post('/order/updateReferenceCode', body),
    uploadSizeGroupExcel: (formData, params) => API.post('/order/uploadSizeGroupExcel', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      params: params
    })

    
  },
  report: {
    create: (params) => API.get('/report/create', { params }),
    createOrder: (params) => API.get('/report/createOrder', { params })
  },
  zaraPriceLabel: {
    cacheQr: (body) => API.post('/zara-price-label/cache-qr', body),
    // QR SVG serve — responseType blob, yeni renderer fazında kullanılacak
    getQr: (cacheKey) => API.get(`/zara-price-label/qr/${cacheKey}`, { responseType: 'blob' })
  },
  pdf: {
    createPDF: (body) => API.post('/pdf/create-pdf', body, { responseType: 'blob' }),
  },
  sizeGroup: {
    list: (brand) => API.get('/sizeGroups/sizeGroups', { params: { brand } }),
    get: (id, brand) => API.get(`/sizeGroups/sizeGroup/${id}`, { params: { brand } }),
    create: (body) => API.post('/sizeGroups/sizeGroup', body),
    update: (id, body) => API.put(`/sizeGroups/sizeGroup/${id}`, body),
    delete: (id, brand) => API.delete(`/sizeGroups/sizeGroup/${id}`, { params: { brand } }),
    addSize: (id, body) => API.post(`/sizeGroups/sizeGroup/${id}/size`, body),
    updateSize: (id, sizeIndex, body) => API.put(`/sizeGroups/sizeGroup/${id}/size/${sizeIndex}`, body),
    deleteSize: (id, sizeIndex, brand) => API.delete(`/sizeGroups/sizeGroup/${id}/size/${sizeIndex}`, { params: { brand } }),
    updateSizeRow: (id, sizeId, body) => API.put(`/sizeGroups/sizeGroup/${id}/sizeRow/${sizeId}`, body),
    deleteSizeRow: (id, sizeId, brand) => API.delete(`/sizeGroups/sizeGroup/${id}/sizeRow/${sizeId}`, { params: { brand } })
  },
}

export default requests
